window.addEventListener('DOMContentLoaded', () => {
  const videoOverlays = document.querySelectorAll('.js-video-overlay');
  const firstScriptTag = document.getElementsByTagName('script')[0];
  const tag = document.createElement('script');
  const queuedPlayers = []; // Queue to store player initialization data

  function onYouTubeIframeAPIReady() {
    queuedPlayers.forEach(({ video, overlay }) => {
      initPlayer(video, overlay);
    });
  }

  function initPlayer(video, overlay) {
    new YT.Player(video, {
      events: {
        onReady: () => console.log('Player is ready'),
        onStateChange: (event) => {
          overlay.classList.add('-isActive');
        },
      },
    });
  }

  videoOverlays.forEach((overlay) => {
    const video = overlay.querySelector('.js-video-overlay iframe');
    video.src = video.src.includes('?')
      ? `${video.src}&enablejsapi=1&origin=${window.location.origin}`
      : `${video.src}?enablejsapi=1&origin=${window.location.origin}`;

    // Queue this player for initialization
    queuedPlayers.push({ video, overlay });

    /**
     * YouTube API
     * Append youtube iFrame API from https://www.youtube.com/iframe_api
     * docs: https://developers.google.com/youtube/iframe_api_reference#Getting_Started
     */

    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        tag.src = 'https://www.youtube.com/iframe_api';
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
        // console.log('Script added, players queued');
      }
    } else {
      initPlayer(video, overlay);
      // console.log('Player initialized directly');
    }
  });
});
